import React from 'react';
import styled from '@emotion/styled';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props =>
    props.bgColor === false ? 'none' : props.theme.colors.primary.lighter};
  padding: 20px 0;
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1000px;

  @media (min-width: ${props =>
      props.theme.breakpoints.s}) and (max-width: ${props =>
      props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const SectionTitle = styled.h2`
  font-size: 32px;
  margin: 35px 0;
  text-align: center;
  color: ${props => props.theme.colors.black.base};
`;
const Items = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
const Item = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  margin: 20px 0;
  max-width: 400px;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    min-width: 360px;
  }
`;
const ItemTitle = styled.h3`
  font-size: 20px;
  min-height: 50px;
  margin: 0;
  text-align: center;
  font-weight: bold;
  font-family: ${props => props.theme.fontFamily.body};
`;
const ItemDescription = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${props => props.theme.colors.black.base};
  text-align: center;
`;

const DescriptionText = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${props => props.theme.colors.black.base};
  margin-bottom: 30px;
  font-weight: 500;
`;

const TechnologyFeatures = props => {
  const { content, hasBackground, titleNoHighlight, bgColor } = props;
  const { title, items } = content ? content : {};
  const itemsRows = items ? chunkArrayInGroups(items, items.length <= 4 ? 2 : 3) : [];

  return (
    <Section bgColor={bgColor}>
      <ContentWrapper>
        <SectionTitle textNoHighlight={hasBackground || titleNoHighlight}>
          {title ? title : 'Technology'}
        </SectionTitle>
        {itemsRows.map((items, rowIdx) => {
          return (
            <Items key={`row_${rowIdx}`}>
              {items.map((item, idx) => {
                const Icon = styled(item.icon)`
                  min-width: 65px;
                  height: 65px;
                  margin-bottom: 30px;
                `;
                return (
                  <Item key={idx}>
                    <Icon />
                    {item.title && <ItemTitle>{item.title}</ItemTitle>}
                    <ItemDescription>{item.description}</ItemDescription>
                  </Item>
                );
              })}
            </Items>
          );
        })}
        {props.footerText ? (
          <DescriptionText>{props.footerText}</DescriptionText>
        ) : null}
      </ContentWrapper>
    </Section>
  );
};

const chunkArrayInGroups = (arr, size) => {
  let groups = [];
  for (let i = 0; i < arr.length; i += size) {
    groups.push(arr.slice(i, i + size));
  }
  return groups;
};

export default TechnologyFeatures;
